import { render, staticRenderFns } from "./ku-info.vue?vue&type=template&id=a6e71968&scoped=true"
import script from "./ku-info.vue?vue&type=script&lang=js"
export * from "./ku-info.vue?vue&type=script&lang=js"
import style0 from "./ku-info.vue?vue&type=style&index=0&id=a6e71968&prod&lang=scss"
import style1 from "./ku-info.vue?vue&type=style&index=1&id=a6e71968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e71968",
  null
  
)

export default component.exports